import {useMemo, useState} from 'react';
import PropTypes from 'prop-types';

import {Box, useMultiStyleConfig} from '@amblique/base/app/components/shared/ui';
import {Component} from '@amblique/king-living/app/components/contentful/component';
import {Swiper} from '@amblique/king-living/app/components/shared/swiper';

/**
 * MediaCarousel component
 * Override this component in your package to provide custom implementation.
 *
 * @param {Object} props - Component props
 * @param {Contentful.MediaCarousel} props.component - MediaCarousel component data
 * @param {boolean} [props.isComplete] - Whether component has all fields
 * @param {boolean} [props.isFetching] - Whether additional data is being fetched
 * @returns {React.ReactElement}
 */
export const MediaCarousel = ({component, isComplete = true, isFetching = false, ...props}) => {
  const {appearance, presets, options, thumbnailsCollection} = component;
  const [thumbnailsSwiper, setThumbnailsSwiper] = useState(null);
  const styles = useMultiStyleConfig('Swiper', {variant: appearance});

  const thumbsOptions = useMemo(() => ({
    swiper: thumbnailsSwiper,
  }), [thumbnailsSwiper]);

  return isComplete ? (
    <Box {...styles.root} {...props}>
      {thumbnailsCollection?.items?.length > 0 && (
        <Swiper
          options={options}
          presets={`${appearance ? `${appearance}-Thumbs` : ''}, ${presets ? `${presets}-Thumbs` : ''}`}
          variant={appearance ? `${appearance}-Thumbs` : ''}
          onSwiper={setThumbnailsSwiper}
        >
          {thumbnailsCollection.items.map((thumbnail) => (
            <Component key={thumbnail.sys.id} component={thumbnail} />
          ))}
        </Swiper>
      )}

      {/* <Box as={appearance === 'CF-022' || appearance === 'CF-046' ? Container : Fragment}> */}
      <Swiper
        // as={appearance === 'CF-022' || appearance === 'CF-046' ? Container : Fragment}
        options={options}
        presets={`${appearance || ''}, ${presets || ''}`}
        thumbs={thumbsOptions}
        variant={appearance}
      >
        {component.imagesCollection.items.map((item) => (
          <Component key={item.sys.id} component={item} />
        ))}
      </Swiper>
      {/* </Box> */}
    </Box>
  ) : null;
};

MediaCarousel.displayName = 'MediaCarousel';
MediaCarousel.propTypes = {
  component: PropTypes.object.isRequired,
  isComplete: PropTypes.bool,
  isFetching: PropTypes.bool,
};
